import { documentations } from "../consts/docs";

export default function getDocDetailService({ type }) {
  return documentations.filter((service) => service.key === type)[0];
}
